module.exports = "<ion-list class=\"list {{ hideAvatar }}\">\r\n    <message-item ng-repeat=\"msgItem in messageWrappers | unique:'id'\"></message-item>\r\n    <div ng-if=\"noMail !== undefined && noMail\" class=\"dir-empty\">\r\n      <i class=\"icon iconfont icon-iconinbox none-logo\"></i>\r\n      <p>{{'TIPS.NO_MAILS' | translate}}</p>\r\n      <P style=\"line-height: 1.4em;\" ng-if=\"fid === -1\">{{'TIPS.VIP_TIPS_PART1' | translate}}</P>\r\n      <P style=\"margin-top:0px;line-height: 1.4em;\" ng-if=\"fid === -1\">{{'TIPS.VIP_TIPS_PART2' | translate}}</P>\r\n    </div>\r\n</ion-list>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/mail/messages.html
// module id = RWVj
// module chunks = 1